/**
 * Setting
 *  API連携、Billing、ユーザー変更・追加など
 */
import setting from '../../api/setting'
import {
  ST_MENU_SELECT,
  ST_BILLING_MODAL,
  ST_BILLING_SAVE
} from '../types'

export default {
  namespaced: true,
  state: {
    isCommonSetting: false,
    isPesonalSetting: true,
    isCompanySetting: false,
    isPlanSetting: false,
    isUserAdminSetting: false,
    isModalSelectBilling: false,
    isNotifySetting: false,
    isAppIconSetting: false,
    billing: {},
    isMenuMiniSize: false
  },
  actions: {
    menuSelectSetting ({commit}, data) {
      console.debug('*** Start *** menuSelectSetting')
      console.debug('data: ' + JSON.stringify(data))
      commit(ST_MENU_SELECT, data)
      console.debug('*** End *** menuSelectSetting')
    },
    modalSelectBilling ({commit}) {
      console.debug('*** Start *** modalSelectBilling')
      commit(ST_BILLING_MODAL)
      console.debug('*** End *** modalSelectBilling')
    },
    billingSave ({commit}, {data, email}) {
      console.debug('*** Start *** billingSave')
      console.debug('data: ' + JSON.stringify(data))
      console.debug('email: ' + JSON.stringify(email))
      commit(ST_BILLING_SAVE, {data, email})
      console.debug('*** End *** billingSave')
    },
    changeMenuMiniSize ({commit, state}) {
      state.isMenuMiniSize = !state.isMenuMiniSize
    }
  },
  mutations: {
    [ST_MENU_SELECT] (state, data) {
      console.debug('*** Start *** ST_MENU_SELECT')
      console.debug('state: ' + JSON.stringify(state))
      console.debug('data: ' + JSON.stringify(data))
      state.isPesonalSetting = false
      state.isPlanSetting = false
      state.isUserAdminSetting = false
      state.isCompanySetting = false
      state.isNotifySetting = false
      state.isCommonSetting = false
      state.isAppIconSetting = false
      state.isPesonalSetting = data === 'isPesonalSetting'
      state.isPlanSetting = data === 'isPlanSetting'
      state.isUserAdminSetting = data === 'isUserAdmin'
      state.isCompanySetting = data === 'isCompanySetting'
      state.isNotifySetting = data === 'isNotifySetting'
      state.isCommonSetting = data === 'isCommonSetting'
      state.isAppIconSetting = data === 'isAppIconSetting'
      console.debug('*** End *** ST_MENU_SELECT')
    },
    [ST_BILLING_MODAL] (state) {
      console.debug('*** Start *** ST_BILLING_MODAL')
      console.debug('state: ' + JSON.stringify(state))
      state.isModalSelectBilling = !state.isModalSelectBilling
      console.debug('*** End *** ST_BILLING_MODAL')
    },
    [ST_BILLING_SAVE] (state, {data, email}) {
      console.debug('*** Start *** ST_BILLING_MODAL')
      console.debug('state: ' + JSON.stringify(state))
      console.debug('data: ' + JSON.stringify(data))
      console.debug('email: ' + JSON.stringify(email))
      setting.createCustomer({data, email})
        .then((d) => {
          console.debug('*** Start *** createCustomer callback')
          console.debug('d: ' + JSON.stringify(d))
          state.billing = d
          state.isModalSelectBilling = false
          console.debug('*** End *** createCustomer callback')
        })
      console.debug('*** Start *** ST_BILLING_MODAL')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/setting.js